import React from 'react';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { isPdfFile } from '../../lib/informedConsentFile';
import TooltipPreset from '../common/TooltipPreset';
import { BoxedWrapper } from '../BoxedWrapper';

import InformedConsentFilePicker from './InformedConsentFilePicker';
import { IExtendsInformedConsentModal, informedConsentModalActionCreators } from './informedConsentModalReducer';
import InformedConsentWrapper from './InformedConsentWrapper';

const { selectReportAction } = informedConsentModalActionCreators;

export default function InformedConsentFormSelect({ dispatchModal, currentTimeframe }: IExtendsInformedConsentModal) {
    return (
        <InformedConsentWrapper currentTimeframe={currentTimeframe}>
            <BoxedWrapper className="section-2">
                <div className="mt-5">
                    <h5>
                        Upload Signed Informed Consent <b>.PDF</b> Forms
                        <TooltipPreset text="Upload a file with all of your clients served in the data period above. Make sure that your file is a .PDF file and includes all signed consent forms in one file.">
                            <FontAwesomeIcon className="mt-1 ml-2 file-upload-tooltip" icon={faQuestionCircle} />
                        </TooltipPreset>
                    </h5>
                    <InformedConsentFilePicker
                        accept=".pdf"
                        validate={isPdfFile}
                        onSelect={(file) => dispatchModal(selectReportAction(file))}
                    />
                </div>
            </BoxedWrapper>
        </InformedConsentWrapper>
    );
}
